<mat-dialog-content class="container">
    <div class="flex column gap-20 ">
		<div class="flex row space-between">
			<h4>{{ 'general.add_to_cart' | translateWithKeys}}</h4>
			<button mat-icon-button (click)="dismiss()"> <mat-icon>close</mat-icon> </button>
		</div>
        <div class="row flex content-container" >
			<img class="cat-image" src="{{data?.category?.image}}" alt="">
			<div class="flex column">
				<h5 [title]="data?.category?.name">{{data?.category?.name | truncate:30}}</h5>
				<p>{{data?.category?.author}}</p>
				<h4>{{data?.category?.price | currency:null:'symbol':'0.0-2' | truncate:20 }}</h4>
			</div>
		</div>

    </div>
</mat-dialog-content>

<mat-dialog-actions align="center">
	<div class="btn-container">
		<button mat-stroked-button class="button" (click)="goBackToCategories()">{{ 'general.continue_shopping' | translateWithKeys}}</button>
		<button mat-flat-button class="button bg-primary-darker text-accent-lighter" (click)="goToCart()">{{ 'general.go_to_cart' | translateWithKeys}}</button>
	</div>
</mat-dialog-actions>
